import { connect } from 'react-redux';
import { setIsConsultantsListLoading } from '../../../actions/consultantActions';

// on importe le composant de présentation
import NavBar from '../../../components/Header/NavBar';

// === mapStateToProps
// si on a besoin de lire des informations dans le state
const mapStateToProps = () => ({
  // nom de la prop à remplir: élément à récupérer dans le state
});

// === mapDispatchToProps
// si on a besoin de dispatcher des actions vers le store (modifier le state)
const mapDispatchToProps = (dispatch) => ({
  // nom de la prop à remplir: fonction qui dispatch l'action
  setIsConsultantsListLoading: (selectedCompany) => {
    dispatch(setIsConsultantsListLoading(selectedCompany));
  },
});

// === création de l'assistant
export default connect(mapStateToProps, mapDispatchToProps)(NavBar);